var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFontBoldIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 51,
    viewBox: "0 0 37 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50.5901V0.590095H21.1406C23.6412 0.587383 26.0912 1.33061 28.2058 2.73342C30.3205 4.13623 32.0131 6.14102 33.0869 8.51484C34.1607 10.8887 34.5716 13.534 34.2719 16.1436C33.9722 18.7532 32.9742 21.2197 31.3938 23.2568C33.7836 25.2123 35.5325 27.9037 36.3963 30.9549C37.2601 34.0061 37.1955 37.2647 36.2117 40.2755C35.2278 43.2863 33.3738 45.8988 30.9087 47.7481C28.4435 49.5973 25.4904 50.5909 22.4619 50.5901H0ZM19.8193 28.3679H10.5703V42.2568H19.8193C21.5715 42.2568 23.2518 41.5251 24.4908 40.2228C25.7297 38.9204 26.4258 37.1541 26.4258 35.3123C26.4258 33.4705 25.7297 31.7042 24.4908 30.4018C23.2518 29.0995 21.5715 28.3679 19.8193 28.3679ZM10.5703 8.92343V20.0345H18.498C19.8998 20.0345 21.2441 19.4492 22.2352 18.4074C23.2264 17.3655 23.7832 15.9524 23.7832 14.479C23.7832 13.0056 23.2264 11.5925 22.2352 10.5506C21.2441 9.50874 19.8998 8.92343 18.498 8.92343H10.5703Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontBoldIcon);
export default __webpack_public_path__ + "static/media/fontBoldIcon.6a6ed9e41d177d77e197ef4accb3b100.svg";
export { ForwardRef as ReactComponent };